import axios from "axios";
import {
  recordWastage,
  getWastageReasons,
  getWastageAnalytics,
  getWastageTrend,
  getExcessStock,
  createExcessStock,
  findMatchingExcess,
  applyExcessStock,
  getBufferConfig,
} from "./inventoryApi";
import { getJobWastageSummary } from "./jobApi";

// Re-export everything that already exists in inventoryApi / jobApi
export {
  recordWastage,
  getWastageReasons,
  getWastageAnalytics,
  getWastageTrend,
  getExcessStock,
  createExcessStock,
  findMatchingExcess,
  applyExcessStock,
  getBufferConfig,
  getJobWastageSummary,
};

// ── Additional Wastage endpoints not in inventoryApi ─────────

/**
 * Get a single wastage entry.
 * GET /v1/wastage/:id
 */
export const getWastageEntry = async (id) => {
  const response = await axios.get(`wastage/${id}`);
  return response.data;
};

/**
 * Update a wastage entry.
 * PUT /v1/wastage/:id
 * Updatable: reason_category, reason_code, reason_detail, material_cost, labor_cost, photos, notes
 */
export const updateWastageEntry = async (id, data) => {
  const response = await axios.put(`wastage/${id}`, data);
  return response.data;
};

/**
 * Delete a wastage entry.
 * DELETE /v1/wastage/:id
 * Side-effect: recalculates job total_wastage and wastage_pct
 */
export const deleteWastageEntry = async (id) => {
  const response = await axios.delete(`wastage/${id}`);
  return response.data;
};

/**
 * Create a wastage reason.
 * POST /v1/wastage/reasons
 * @param {{ code, name, category, applicable_stages[], is_active }} data
 */
export const createWastageReason = async (data) => {
  const response = await axios.post("wastage/reasons", data);
  return response.data;
};

// ── Buffer ───────────────────────────────────────────────────

/**
 * Update buffer configuration.
 * PUT /v1/wastage/buffer/config
 * @param {{ id?, buffer_pct, min_buffer_qty, max_buffer_pct, box_type_id?, ply?, is_active }} data
 */
export const updateBufferConfig = async (data) => {
  const response = await axios.put("wastage/buffer/config", data);
  return response.data;
};

/**
 * Calculate buffer for a given order quantity.
 * POST /v1/wastage/buffer/calculate
 * @param {{ quantity, box_type_id?, ply? }} data
 * @returns {{ buffer_pct, buffer_qty, production_qty }}
 */
export const calculateBuffer = async (data) => {
  const response = await axios.post("wastage/buffer/calculate", data);
  return response.data;
};
